import React from 'react';
import { ResourceProps } from 'react-admin';

// Analíticas, escena Tenencias. Misma pantalla que `/metrics`: la ruta decide
// con qué escena abre. Se conserva para que los enlaces guardados no se rompan.
let resourceProps: ResourceProps = {
  name: 'holdings',
  list: React.lazy(() => import(/* webpackChunkName: "c-analiticas" */ '../../console/pages/analiticas')),
};

export default resourceProps;
